import { render, staticRenderFns } from "./popconfirm4.vue?vue&type=template&id=00a12f8d"
import script from "./popconfirm4.vue?vue&type=script&lang=js"
export * from "./popconfirm4.vue?vue&type=script&lang=js"
import style0 from "./popconfirm4.vue?vue&type=style&index=0&id=00a12f8d&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports